import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-[10px] py-[3px] text-[12px] font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--border-focus)] focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-[var(--accent-gold-soft)] text-[var(--accent-ink-dark)] hover:opacity-80",
        secondary:
          "border-transparent bg-[var(--surface-sunk)] text-[var(--ink-primary)] hover:opacity-80",
        destructive:
          "border-transparent bg-[var(--semantic-error)] text-[var(--ink-inverse)] shadow hover:opacity-80",
        outline: "text-[var(--ink-primary)] border-[var(--border-strong)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const CE_TOKENS = {
  'CE-01': { bg: 'var(--ce-01-romance)',   ink: 'var(--ce-01-romance-ink)' },
  'CE-02': { bg: 'var(--ce-02-joy)',       ink: 'var(--ce-02-joy-ink)' },
  'CE-03': { bg: 'var(--ce-03-sorrow)',    ink: 'var(--ce-03-sorrow-ink)' },
  'CE-04': { bg: 'var(--ce-04-fury)',      ink: 'var(--ce-04-fury-ink)' },
  'CE-05': { bg: 'var(--ce-05-wonder)',    ink: 'var(--ce-05-wonder-ink)' },
  'CE-06': { bg: 'var(--ce-06-dread)',     ink: 'var(--ce-06-dread-ink)' },
  'CE-07': { bg: 'var(--ce-07-revulsion)', ink: 'var(--ce-07-revulsion-ink)' },
  'CE-08': { bg: 'var(--ce-08-valor)',     ink: 'var(--ce-08-valor-ink)' },
  'CE-09': { bg: 'var(--ce-09-serenity)',  ink: 'var(--ce-09-serenity-ink)' },
};

function Badge({
  className,
  variant,
  ce,
  style,
  ...props
}) {
  let combinedStyle = { ...style };
  if (ce && CE_TOKENS[ce]) {
    combinedStyle.backgroundColor = CE_TOKENS[ce].bg;
    combinedStyle.color = CE_TOKENS[ce].ink;
  }
  return (<div className={cn(badgeVariants({ variant }), className)} style={combinedStyle} {...props} />);
}

export { Badge, badgeVariants }